import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

import HeaderAlter from '../components/HeaderAlter';
import Hero from '../components/Hero';
import Body from '../components/BodyCancelar';
import Footer from '../components/Footer';

function CancelacionVisita() {
  const { refVisita } = useParams();

  return (
    <Box
  sx={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden'
  }}
>
  <HeaderAlter />

  <Box sx={{ mt: 4 }}>
    <Body refVisita={refVisita} />
  </Box>
  <Hero />
  <Box sx={{ mt: 'auto' }}>
    <Footer />
  </Box>
</Box>
  );
}

export default CancelacionVisita;